import {SecurityStatusDTO} from "@/shared/timr";

export class SecurityStatus {

	// Accumulated across updates, so individual flags may be missing until fully loaded.
	public static status: Partial<SecurityStatusDTO> = {};

	public static update(status: SecurityStatusDTO | undefined) {
		if (!status) {
			return;
		}
		for (const key of Object.keys(status) as (keyof SecurityStatusDTO)[]) {
			if (status[key] != null) {
				SecurityStatus.status[key] = status[key];
			}
		}
	}

	public static isAllowed(key: keyof SecurityStatusDTO): boolean {
		return SecurityStatus.status[key] === true;
	}

	public static isAddTaskAllowed(): boolean {
		return SecurityStatus.isAllowed("addTaskAllowed");
	}

	public static isAddDriveLogCategoryAllowed(): boolean {
		return SecurityStatus.isAllowed("addDriveLogCategoryAllowed");
	}

	public static isAddUserAllowed(): boolean {
		return SecurityStatus.isAllowed("addUserAllowed");
	}

	public static isAddWorkingTimeTypeAllowed(): boolean {
		return SecurityStatus.isAllowed("addWorkingTimeTypeAllowed");
	}

	public static isAddCarAllowed(): boolean {
		return SecurityStatus.isAllowed("addCarAllowed");
	}

	public static isStartWorkingTimeAllowed(): boolean {
		return SecurityStatus.isAllowed("startWorkingTimeAllowed");
	}

	public static isAddWorkingTimeAllowed(): boolean {
		return SecurityStatus.isAllowed("addWorkingTimeAllowed");
	}

	public static isStartProjectTimeAllowed(): boolean {
		return SecurityStatus.isAllowed("startProjectTimeAllowed");
	}

	public static isAddProjectTimeAllowed(): boolean {
		return SecurityStatus.isAllowed("addProjectTimeAllowed");
	}

	public static isStartDriveLogAllowed(): boolean {
		return SecurityStatus.isAllowed("startDriveLogAllowed");
	}

	public static isAddDriveLogAllowed(): boolean {
		return SecurityStatus.isAllowed("addDriveLogAllowed");
	}

	public static isRevisionsAllowed(): boolean {
		return SecurityStatus.isAllowed("revisionsAllowed");
	}

	public static isCorporateFeaturesAllowed(): boolean {
		return SecurityStatus.isAllowed("corporateFeaturesAllowed");
	}

	public static isBudgetsAllowed(): boolean {
		return SecurityStatus.isAllowed("budgetsAllowed");
	}

	public static isTimeAccountAllowed(): boolean {
		return SecurityStatus.isAllowed("timeAccountAllowed");
	}

	public static isLockTaskAllowed(): boolean {
		return SecurityStatus.isAllowed("lockTaskAllowed");
	}

	public static isRecordingRestrictionsAllowed(): boolean {
		return SecurityStatus.isAllowed("recordingRestrictionsAllowed");
	}

	public static isWorkingTimeRequestsEnabled(): boolean {
		return SecurityStatus.isAllowed("workingTimeRequestsAllowed") && globals.workingTimeRequestsEnabled;
	}

	public static isPasswordChangeAllowed(): boolean {
		return SecurityStatus.isAllowed("passwordChangeAllowed");
	}

	public static isOvertimeAllowanceAllowed(): boolean {
		return SecurityStatus.isAllowed("overtimeAllowanceAllowed");
	}

	public static isTravellingTimeAllowed(): boolean {
		return SecurityStatus.isAllowed("travellingTimeAllowed");
	}

	public static isTrustBasedWorkingTimeAllowed(): boolean {
		return SecurityStatus.isAllowed("trustBasedWorkingTimeAllowed");
	}

	public static isEnhancedWorkingTimeTypesAllowed(): boolean {
		return SecurityStatus.isAllowed("enhancedWorkingTimeTypesAllowed");
	}

	public static isPresenceBoardAllowed(): boolean {
		return SecurityStatus.isAllowed("presenceBoardAllowed");
	}

	public static isDistanceAutocompletionAllowed(): boolean {
		return SecurityStatus.isAllowed("distanceAutocompletionAllowed");
	}

	public static isCustomFieldsForRecordAllowed(): boolean {
		return SecurityStatus.isAllowed("customFieldsForRecordAllowed");
	}

	public static isTourSyncAllowed(): boolean {
		return SecurityStatus.isAllowed("tourSyncAllowed");
	}

	public static isWorkingTimeRequestsAllowed(): boolean {
		return SecurityStatus.isAllowed("workingTimeRequestsAllowed");
	}

	public static isTaskLocationsAllowed(): boolean {
		return SecurityStatus.isAllowed("taskLocationsAllowed");
	}

	public static isGeofenceAllowed(): boolean {
		return SecurityStatus.isAllowed("geofenceAllowed");
	}

	public static isExternalUserSyncAllowed(): boolean {
		return SecurityStatus.isAllowed("externalUserSyncAllowed");
	}

	public static isDisableBrandingAllowed(): boolean {
		return SecurityStatus.isAllowed("disableBrandingAllowed");
	}

	public static isVacationAccountAllowed(): boolean {
		return SecurityStatus.isAllowed("vacationAccountAllowed");
	}

	public static isHolidayCalendarAllowed(): boolean {
		return SecurityStatus.isAllowed("holidayCalendarAllowed");
	}

	public static isSubstitutesAllowed(): boolean {
		return SecurityStatus.isAllowed("substitutesAllowed");
	}

	public static isPaidTimeOffCompensationAllowed(): boolean {
		return SecurityStatus.isAllowed("paidTimeOffCompensationAllowed");
	}

	public static isProjectTimeAttachmentsAllowed(): boolean {
		return SecurityStatus.isAllowed("projectTimeAttachmentsAllowed");
	}

	public static isWorkingTimeRequestsMultistepAllowed(): boolean {
		return SecurityStatus.isAllowed("workingTimeRequestsMultistepAllowed");
	}

	public static isAlternatingWorkScheduleModelsAllowed(): boolean {
		return SecurityStatus.isAllowed("alternatingWorkScheduleModelsAllowed");
	}

	public static isProofsAllowed(): boolean {
		return SecurityStatus.isAllowed("proofsAllowed");
	}

	public static isWorkingTimeNoticesAllowed(): boolean {
		return SecurityStatus.isAllowed("workingTimeNoticesAllowed");
	}
}
